(function () {
  'use strict';

  angular.module('app').component('teamMembersPage', teamMemberListComponent());

  function teamMemberListComponent() {
    return {
      bindings: {},
      controller: TeamMemberListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/team-members/team-members-page.component.html',
    };
  }

  TeamMemberListCtrl.$inject = ['$location', 'AbilityService', 'TeamMemberService'];

  function TeamMemberListCtrl($location, AbilityService, TeamMemberService) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_teammember_accountadmin'),
    };

    // Methods
    vm.createItem = createItem;
    vm.onShowTeamMember = onShowTeamMember;

    // Initializers
    getTeamMembers();

    function getTeamMembers() {
      vm.loadingItems = true;
      TeamMemberService.getTeamMembers().then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    function createItem() {
      $location.path('/team_members/new');
    }

    function onShowTeamMember(item, mode) {
      $location.path(`/team_members/${item.id}`).search({ mode: mode });
    }
  }
})();
